/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpServiceAccountResponse { 
    /**
     * A user-specified, human-readable description of the service account.
     */
    description?: string;
    /**
     * A user-specified, human-readable name for the service account.
     */
    display_name?: string;
    /**
     * The email address of the service account.
     */
    email: string;
    /**
     * Service account name
     */
    name: string;
    /**
     * The OAuth 2.0 client ID for the service account.
     */
    oauth2_client_id?: string;
    /**
     * The project id that service account operates on.
     */
    project_id: string;
    /**
     * The unique, stable numeric ID for the service account.
     */
    unique_id: string;
}

